import React from 'react';
import Icon from "./Icon";

const IconParking = ({tooltip}) => {
    return (
        <Icon image="/img/icons/icon-parking.svg" tooltip={tooltip}/>
    )
};

export default IconParking;